import React from 'react';

export default class PageBody extends React.PureComponent {
    render() {
        const { children } = this.props;

        return <div className="builder-page-body">{children}</div>;
    }
}
